import { useQuery } from 'react-query';
import axios from 'axios';
import { AdminAnalyticsAndReportsAPI } from '../../../../constants/API';
import { commonHeaders } from '../../../../constants/HeadersAPI';
import { AnalyticsAndReportsDateType } from '../../../../types/Admin/AnalyticsAndReports';

type VisitorsReportType = {
  date: string;
  registeredClients: string;
  clientsCalledFromQueue: string;
  clientsDone: string;
  clientsRedirect: string;
  clientsNotCome: string;
  avgTimeInQueue: string;
  serviceAvgTime: string;
};

const parseNumberLoose = (value: unknown) => {
  const raw = String(value ?? '').trim();
  if (!raw) return 0;
  const parsed = Number(raw.replace(/[^\d.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : 0;
};

export const useGetVisitorsReport = (date: AnalyticsAndReportsDateType) => {
  const {
    data: visitorsReportResp,
    isFetching: isLoadingVisitorsReport,
    isSuccess: isVisitorsReportRecieved,
    refetch: refetchVisitorsReport
  } = useQuery(
    ['visitorsReport', date.startDate, date.endDate, date.branchQueueId ?? null],
    () =>
      axios.get<VisitorsReportType[]>(
        `${AdminAnalyticsAndReportsAPI.getVisitorsReport}?startDate=${date.startDate}&endDate=${date.endDate}${
          date.branchQueueId ? `&branchQueueId=${date.branchQueueId}` : ''
        }`,
        commonHeaders()
      ),
    {
      enabled: date.branchQueueId != null,
      select: ({ data }) => {
        if (!data?.length) return [];

        const rows = data.map((e) => {
          return {
            date: e.date,
            registred: e.registeredClients,
            calledFromQueue: e.clientsCalledFromQueue,
            served: e.clientsDone,
            redirected: e.clientsRedirect,
            missed: e.clientsNotCome
          };
        });

        const totals = rows.reduce(
          (acc, r) => {
            acc.registered += parseNumberLoose(r.registred);
            acc.called += parseNumberLoose(r.calledFromQueue);
            acc.served += parseNumberLoose(r.served);
            acc.redirected += parseNumberLoose(r.redirected);
            acc.missed += parseNumberLoose(r.missed);

            return acc;
          },
          {
            registered: 0,
            called: 0,
            served: 0,
            redirected: 0,
            missed: 0
          }
        );

        const summaryRow = {
          date: 'Итого',
          registred: String(totals.registered),
          calledFromQueue: String(totals.called),
          served: String(totals.served),
          redirected: String(totals.redirected),
          missed: String(totals.missed),
          isSummary: true
        };

        return [...rows, summaryRow];
      }
    }
  );

  return {
    visitorsReportResp,
    isLoadingVisitorsReport,
    isVisitorsReportRecieved,
    refetchVisitorsReport
  };
};
